import { ISummaryFilters, ISummaryFiltersRequest } from './interfaces';

export const parsedFiltersRequest = (
  filters: ISummaryFilters,
): ISummaryFiltersRequest => {
  const defaultParams = {
    paymentDateStart: new Date(filters.startDate).toISOString(),
    paymentDateEnd: new Date(filters.endDate).toISOString(),
  };

  return Object.assign(
    defaultParams,
    filters.eps ? { epsTotal: filters.eps } : {},
    filters.serviceCategory
      ? { serviceCategoryTotal: filters.serviceCategory }
      : {},
  );
};

export const parsedFiltersState = (
  filters: ISummaryFilters,
): ISummaryFilters => ({
  eps: filters.eps,
  startDate: new Date(filters.startDate).toISOString(),
  endDate: new Date(filters.endDate).toISOString(),
});
